import useUser from "./useUser";
import type { Authorizable } from "./types";

export const useAuthorization = () => {
    const { hasRole } = useUser();

    const isAuthorized = (roles: Authorizable['roles'] = []) => (
        !roles.length ||
        hasRole(roles)
    );

    const withAuthorization = <T extends Authorizable>(collection: Array<T>) => (
        collection.filter(item => isAuthorized(item.roles))
    );

    return {
        isAuthorized,
        withAuthorization
    };
};

export default useAuthorization;
